import { Doc } from '@dadohr/shared/domainTypes/document';
import { IExperienceTemplate } from '@dadohr/shared/domainTypes/experience';
import { PAEventType } from '@dadohr/shared/domainTypes/productAnalytics';
import { Button } from '@material-ui/core';
import { Edit } from 'lucide-react';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useUnsafeTranslation } from '../../../../i18next';
import { useRoutes } from '../../../../routes';
import { useCurrentUser } from '../../../../services/currentUser';
import { hasCurrentUserExperienceLevelScopes } from '../../../../services/permissions';
import { useProductAnalytics } from '../../../../services/productAnalytics';

export const GoToTimelineElementEditButton = ({
  expTpl,
  type,
  elementId,
  title
}: {
  expTpl: Doc<IExperienceTemplate>;
  type: 'MESSAGE' | 'TASK' | 'AUTOMATION';
  elementId: string;
  title: string;
}) => {
  const currentUser = useCurrentUser();
  const { t } = useUnsafeTranslation();
  const { ROUTES } = useRoutes();
  const { trackEvent } = useProductAnalytics();
  const params = useMemo(
    () =>
      type === 'MESSAGE'
        ? {
            step: 'tasks' as const,
            messageId: elementId
          }
        : type === 'TASK'
        ? {
            step: 'tasks' as const,
            taskId: elementId
          }
        : type === 'AUTOMATION'
        ? {
            step: 'tasks' as const,
            automationId: elementId
          }
        : {
            // should never happen
            step: 'tasks' as const
          },
    [type, elementId]
  );

  if (!hasCurrentUserExperienceLevelScopes(currentUser, expTpl.id, ['edit'])) {
    return null;
  }
  return (
    <Link to={ROUTES.experiences.details.edit.url(expTpl.id, params)}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Edit size={14} />}
        onClick={() => {
          trackEvent({
            eventType: PAEventType.EXPERIENCE_TPL,
            name: 'Edit Timeline Item Button Clicked',
            'Experience Template ID': expTpl.id,
            Explanation:
              'Admin user clicks an edit button in a task/message/automation view modal',
            'Timeline Item ID': elementId,
            'Timeline Item Type': type,
            'Timeline Item Title': title
          });
        }}
      >
        {type === 'MESSAGE' && t('Edit Message')}
        {type === 'AUTOMATION' && t('Edit Automation')}
        {type === 'TASK' && t('Edit Task')}
      </Button>
    </Link>
  );
};
